import _cloneDeep from 'lodash/cloneDeep';

const BatteryIcons = {
    'VALUE_0': 'fa-battery-empty',
    'VALUE_25': 'fa-battery-quarter',
    'VALUE_50': 'fa-battery-half',
    'VALUE_75': 'fa-battery-three-quarters',
    'VALUE_100': 'fa-battery-full'
};

export default class BatteryStatusController {
    $onInit() {
        if (!this.battery) {
            this.batteryIcon = BatteryIcons.VALUE_0;
        }
    }

    $onChanges(changes) {
        if (changes.battery && !isNaN(parseInt(changes.battery.currentValue, 10))) {
            this.battery = parseInt(_cloneDeep(changes.battery.currentValue), 10);
        } else {
            this.battery = 0;
        }

        this.calculateIcon();
    }

    calculateIcon() {
        if (this.battery < 25) {
            this.batteryIcon = BatteryIcons.VALUE_0;
            return;
        }

        if (this.battery < 50) {
            this.batteryIcon = BatteryIcons.VALUE_25;
            return;
        }

        if (this.battery < 75) {
            this.batteryIcon = BatteryIcons.VALUE_50;
            return;
        }

        if (this.battery < 90) {
            this.batteryIcon = BatteryIcons.VALUE_75;
            return;
        }

        this.batteryIcon = BatteryIcons.VALUE_100;
    }
}



// WEBPACK FOOTER //
// ./app/common/battery-status/battery-status.controller.js